import React, { useState, useEffect } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import Testimonials from "../components/Testimonials";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "../styles/Home.css";


import home1 from "../assets/home1.jpg";
import home2 from "../assets/home2.jpg";

import bg1 from "../assets/bg1.jpg";
import bg2 from "../assets/bg2.jpg";
import bg3 from "../assets/bg3.jpg";
import bg4 from "../assets/bg4.jpg";

import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PaymentsIcon from "@mui/icons-material/Payments";
import UmbrellaIcon from "@mui/icons-material/Umbrella";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import VerifiedIcon from "@mui/icons-material/Verified";
import VisibilityIcon from "@mui/icons-material/Visibility";

import CostEstimator from "../components/CostEstimator";

const Home = () => {
  const navigate = useNavigate();

  const [bgIndex, setBgIndex] = useState(0);
  const bgImages = [bg1, bg2, bg3, bg4];

  // Auto-slide every 6 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prev) => (prev + 1) % bgImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [bgImages.length]);

  const cards = [
    { id: 1, title: "Labour Contracts", description: "Starts from ₹350 per sqft", img: home1, path: "/page1" },
    { id: 2, title: "Material Contracts", description: "Starts from ₹1400 per sqft", img: home2, path: "/page2" },
  ];

  const whyChoose = [
    { icon: <PeopleAltIcon fontSize="large" className="why-icon" />, title: "No Third-Party Vendor", desc: "We execute projects fully in-house for best quality." },
    { icon: <PaymentsIcon fontSize="large" className="why-icon" />, title: "Micro Payments", desc: "Pay per stage — up to 25 small, secure payments." },
    { icon: <UmbrellaIcon fontSize="large" className="why-icon" />, title: "No Advance", desc: "Pay only after completion of each work stage." },
    { icon: <HomeWorkIcon fontSize="large" className="why-icon" />, title: "Expert Designs", desc: "Our in-house architects ensure aesthetic & functional spaces." },
    { icon: <VerifiedIcon fontSize="large" className="why-icon" />, title: "Quality Checks", desc: "We perform 400+ quality inspections per project." },
    { icon: <VisibilityIcon fontSize="large" className="why-icon" />, title: "Project Monitoring", desc: "24/7 live updates & engineer supervision daily." },
  ];

  return (
    <Box className="home-container">
      {/* ===== Sliding Background ===== */}
      <motion.div
        key={bgIndex}
        className="background-slider"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1.2 }}
        style={{
          backgroundImage: `url(${bgImages[bgIndex]})`,
        }}
      />

      {/* ===== Content Overlay ===== */}
      <Box className="home-content">
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h3" className="home-title">
            Welcome to RM INFRASTRUCTURES
          </Typography>
        </motion.div>

        {/* ==== Top 2 Cards ==== */}
        <Grid container spacing={5} justifyContent="center" alignItems="center" className="home-grid">
          {cards.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={card.id}>
              <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.97 }}>
                <Card className="home-card" onClick={() => navigate(card.path)} elevation={6}>
                  <CardActionArea>
                    <CardMedia component="img" height="200" image={card.img} alt={card.title} />
                    <CardContent>
                      <Typography variant="h6" className="card-title">
                        {card.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" className="card-description">
                        {card.description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {/* ==== Why Choose ==== */}
        <Box className="why-container">
          <Typography variant="h4" className="why-title">
            Why Choose RM Infrastructures
          </Typography>
          <Typography variant="subtitle1" className="why-subtitle">
            Combining innovative design with expert craftsmanship to bring your dream home to life.
          </Typography>

          <Grid container spacing={4} justifyContent="center">
            {whyChoose.map((item, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <motion.div className="why-card" whileHover={{ scale: 1.05 }}>
                  <Box className="why-icon-box">{item.icon}</Box>
                  <Typography variant="h6" className="why-card-title">
                    {item.title}
                  </Typography>
                  <Typography variant="body2" className="why-card-desc">
                    {item.desc}
                  </Typography>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* ==== Cost Estimator ==== */}
        <Box className="estimator-section">
          <CostEstimator />
        </Box>

        <Box className="home-container">
        {/* your other sections */}
         <Testimonials />
        </Box>

        
         
      </Box>
      
      
    </Box>
  );
};

export default Home;
